<template>
<span class="capacity-block">
    <div class="number">
        <span v-if="capacityBlockData.type=='energyStorage'" class="value">{{capacityBlockData.power}}<span class="unit">{{capacityBlockData.powerUnit}}</span></span>
        <span v-if="capacityBlockData.type=='energyStorage'" class="value">/{{capacityBlockData.number}}</span>
        <span v-if="capacityBlockData.type!='energyStorage'" class="value">{{capacityBlockData.number}}</span>
        <span class="unit">{{capacityBlockData.unit}}</span>
    </div>
    <div class="title">{{capacityBlockData.title}}</div>
</span>
</template>

<script>
export default {
    props: ['listData'],
    data() {
        return {
            capacityBlockData: {}
        }
    },
    mounted() {
    },
    watch: {
        listData(val) {
            this.capacityBlockData = val;
        }
    },
    methods: {}
}
</script>

<style lang="scss">
.capacity-block {
    padding-left: 34%;
    padding-top: 5%;

    .number {
        color: #033A7C;
        line-height: 4vh;
    }

    .value {
        font-size: 22px;
        font-family: DINBold;
        font-weight: bold;
    }

    .unit {
        font-size: 14px;
        font-family: DINBold;
        font-weight: bold;
    }

    .title {
        font-size: 14px;
        font-family: 'Microsoft YaHei';
        font-weight: bold;
        color: #19191A;
        margin-top: 0.7vh;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/svolt/components/capacity-block.vue